import WebApp from "@twa-dev/sdk";

/**
 * Open a URL outside the Mini App.
 *
 * Telegram's in-app webview will not save or print a file, so anything the user
 * is meant to keep (a printable PDF) has to be handed to the system browser via
 * `WebApp.openLink`. Outside Telegram — desktop browser, local dev — the SDK
 * method is absent and a normal new tab does the same job.
 */
export function openExternal(url: string) {
  try {
    if (typeof WebApp?.openLink === "function") { WebApp.openLink(url); return; }
  } catch { /* not running inside Telegram — fall through */ }
  window.open(url, "_blank", "noopener,noreferrer");
}

/** Absolute URL for a file served from frontend/public — `openLink` hands the
 *  address to another app, so a relative path would not resolve there. */
export function publicFileUrl(path: string) {
  return new URL(path, window.location.origin).href;
}
